import {defaultDirection} from '../constants/defaultValues';
import Rbac from "../components/Rbac";

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key], B = b[key];
    if (order.indexOf(A + '') > order.indexOf(B + '')) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};


export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return dd + '.' + mm + '.' + yyyy;
};

export const getCurrentTime = () => {
  const now = new Date();
  return now.getHours() + ':' + now.getMinutes();
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem('direction')) {
    const localValue = localStorage.getItem('direction');
    if (localValue === 'rtl' || localValue === 'ltr') {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === 'rtl'
  };
};

export const setDirection = localValue => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  localStorage.setItem('direction', direction);
};

export const hasMenuPermission = (menu) => {
  if (menu.subs) {
    return menu.subs.some(sub => hasMenuPermission(sub))
  }

  if(Array.isArray(menu.permission)){
   return menu.permission.some(permission => Rbac.hasPermission(permission))
  }

  return Rbac.hasPermission(menu.permission)
}

const persianNumberFormatter = new Intl.NumberFormat('fa-IR');

export const formatPersianNumber = value => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const numericValue = typeof value === 'string'
    ? value.replace(/,/g, '')
    : value;

  if (Number.isNaN(Number(numericValue))) {
    return value.toString().replace(/[0-9]/g, digit => '۰۱۲۳۴۵۶۷۸۹'[digit]);
  }

  return persianNumberFormatter.format(Number(numericValue));
};

export const toEnglishNumber = value => {
  if (value === null || value === undefined) {
    return value;
  }

  return value.toString()
    .replace(/[۰-۹]/g, digit => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
    .replace(/[٠-٩]/g, digit => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit));
};

export const formatPersianDigits = value => {
  if (value === null || value === undefined) {
    return '';
  }

  return value.toString()
    .replace(/[0-9]/g, digit => '۰۱۲۳۴۵۶۷۸۹'[digit])
    .replace(/[٠-٩]/g, digit => '۰۱۲۳۴۵۶۷۸۹'['٠١٢٣٤٥٦٧٨٩'.indexOf(digit)]);
};

export const toPersianNumber = formatPersianNumber;
